module.exports = __webpack_public_path__ + "img/grand-restaurant-4.4bb74c9a.jpg";